"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NOT_FOUND_KEY = exports.COMBOBOX_SELECTION_TYPES = void 0;
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _react = _interopRequireWildcard(require("react"));
var _tabbable = require("tabbable");
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _Button = _interopRequireDefault(require("../Buttons/Button"));
var _ValidationMessage = _interopRequireDefault(require("../Forms/_ValidationMessage"));
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _InputField = _interopRequireDefault(require("../InputField/InputField"));
var _Listbox = _interopRequireDefault(require("../List/Listbox"));
var _Overlay = _interopRequireDefault(require("../Overlay/Overlay"));
var _BusyIndicator = _interopRequireDefault(require("../BusyIndicator/BusyIndicator"));
var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes"));
var _isFunction = _interopRequireDefault(require("../utils/isFunction"));
var _isString = _interopRequireDefault(require("../utils/isString"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _isEnterOrSpace = _interopRequireDefault(require("../utils/isEnterOrSpace"));
var _useUpdatesOnlyEffect = _interopRequireDefault(require("../utils/useUpdatesOnlyEffect"));
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _listOptions = require("../utils/_listOptions");
var _constants = require("../utils/constants");
var _listboxUtils = require("../List/_listboxUtils");
var _MultiComboBoxTokenizer = _interopRequireDefault(require("./_MultiComboBoxTokenizer"));
var _utils = require("./_utils");
var _ComboBoxContext = _interopRequireDefault(require("./_ComboBoxContext"));
var _ComboBox = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./ComboBox.css") : void 0);
var _excluded = ["dropdownTriggerButtonRef", "className", "controlRef", "decorators", "disabled", "dropdownTriggerButtonProps", "dropdownTriggerIconName", "dropdownTriggerLabel", "filterable", "filterableMruOptions", "formItemProps", "groupBy", "helpText", "hideNoResultsMsg", "id", "infinite", "inputDescribedby", "inputProps", "inputRef", "isLoading", "itemCountScreenReaderLabel", "itemKey", "itemText", "label", "labelProps", "listboxProps", "listItemProps", "listItemRenderer", "loadingMessage", "localizedTextAddendum", "matcherMethod", "maxHeight", "mruOptions", "onBlur", "onChange", "onDropdownClose", "onDropdownOpen", "onDropdownTriggerClick", "onFocus", "onKeyDown", "onOverflowTokenClick", "onMouseDown", "noResultsMsg", "onSelectionChange", "onTokenClose", "options", "placeholder", "overlayProps", "readOnly", "required", "selectedKey", "selectedKeys", "selectionType", "showOnFocus", "tokenizerRef", "hideDropdownButton", "showAllOptionsOnDropdownOpen", "size", "validationMessage", "value", "mruTitle", "otherGroupHeader"];
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty2(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint-disable max-len */
var CSS_BLOCK = 'sapcnqr-combobox';
var NOT_FOUND_KEY = exports.NOT_FOUND_KEY = 'none';
var COMBOBOX_SELECTION_TYPES = exports.COMBOBOX_SELECTION_TYPES = ['manual', 'auto', 'auto-inline'];

/** A **ComboBox** allows users to select an item from a predefined list.
 * It provides an editable input field for filtering the list,
 * and a dropdown menu with a list of the available options.
 * If the entries are not validated by the application, users can also enter custom values.
 *
 * > Browsers provide suggestions for input fields by default;
 * This component will attempt to disable those suggestions.
 * Please open an issue if you see browser suggestion behavior.
 * See the [support](/docs/introduction-support--docs#autocomplete-attribute-issue) page
 * for more information.
 *
 * Documentation is separated into sections:
 *
 * * [Basic Examples](./?path=/docs/components-controls-inputs-combobox-basic-examples--docs)
 * * [Customization Examples](./?path=/docs/components-controls-inputs-combobox-customization-examples--docs)
 *  */

var ComboBox = /*#__PURE__*/_react.default.forwardRef(function (_props, ref) {
  var _screenReaderStatus, _overlayProps$popperP;
  var addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  var props = addChildProps ? _objectSpread(_objectSpread({}, _props), addChildProps(ComboBox, _props)) : _props;
  var dropdownTriggerButtonRef = props.dropdownTriggerButtonRef,
    className = props.className,
    controlRef = props.controlRef,
    decorators = props.decorators,
    disabled = props.disabled,
    dropdownTriggerButtonProps = props.dropdownTriggerButtonProps,
    dropdownTriggerIconName = props.dropdownTriggerIconName,
    dropdownTriggerLabel = props.dropdownTriggerLabel,
    filterable = props.filterable,
    filterableMruOptions = props.filterableMruOptions,
    formItemProps = props.formItemProps,
    groupBy = props.groupBy,
    helpText = props.helpText,
    hideNoResultsMsg = props.hideNoResultsMsg,
    id = props.id,
    infinite = props.infinite,
    inputDescribedby = props.inputDescribedby,
    inputProps = props.inputProps,
    inputRef = props.inputRef,
    isLoading = props.isLoading,
    itemCountScreenReaderLabel = props.itemCountScreenReaderLabel,
    itemKey = props.itemKey,
    itemText = props.itemText,
    label = props.label,
    labelProps = props.labelProps,
    listboxProps = props.listboxProps,
    listItemProps = props.listItemProps,
    listItemRenderer = props.listItemRenderer,
    loadingMessage = props.loadingMessage,
    localizedTextAddendum = props.localizedTextAddendum,
    matcherMethod = props.matcherMethod,
    maxHeight = props.maxHeight,
    mruOptions = props.mruOptions,
    onBlur = props.onBlur,
    onChange = props.onChange,
    onDropdownClose = props.onDropdownClose,
    onDropdownOpen = props.onDropdownOpen,
    onDropdownTriggerClick = props.onDropdownTriggerClick,
    _onFocus = props.onFocus,
    onKeyDown = props.onKeyDown,
    onOverflowTokenClick = props.onOverflowTokenClick,
    _onMouseDown = props.onMouseDown,
    noResultsMsg = props.noResultsMsg,
    onSelectionChange = props.onSelectionChange,
    onTokenClose = props.onTokenClose,
    options = props.options,
    placeholder = props.placeholder,
    overlayProps = props.overlayProps,
    readOnly = props.readOnly,
    required = props.required,
    selectedKey = props.selectedKey,
    selectedKeys = props.selectedKeys,
    selectionType = props.selectionType,
    showOnFocus = props.showOnFocus,
    tokenizerRef = props.tokenizerRef,
    hideDropdownButton = props.hideDropdownButton,
    showAllOptionsOnDropdownOpen = props.showAllOptionsOnDropdownOpen,
    size = props.size,
    validationMessage = props.validationMessage,
    value = props.value,
    mruTitle = props.mruTitle,
    otherGroupHeader = props.otherGroupHeader,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    isLoadingAllOptions = _useState4[0],
    setIsLoadingAllOptions = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    willFocusPopover = _useState6[0],
    setWillFocusPopover = _useState6[1];
  var _useState7 = (0, _react.useState)(value),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    filterString = _useState8[0],
    setFilterString = _useState8[1];
  var _useState9 = (0, _react.useState)(options),
    _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
    filteredOptions = _useState10[0],
    setFilteredOptions = _useState10[1];
  var _useState11 = (0, _react.useState)(mruOptions),
    _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
    filteredMruOptions = _useState12[0],
    setFilteredMruOptions = _useState12[1];
  var _useState13 = (0, _react.useState)(),
    _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
    selectedOption = _useState14[0],
    setSelectedOption = _useState14[1];
  var _useState15 = (0, _react.useState)([]),
    _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
    multiSelectOptions = _useState16[0],
    setMultiSelectOptions = _useState16[1];
  var _useState17 = (0, _react.useState)(value),
    _useState18 = (0, _slicedToArray2.default)(_useState17, 2),
    nudgeBase = _useState18[0],
    setNudgeBase = _useState18[1];
  var _useState19 = (0, _react.useState)(value),
    _useState20 = (0, _slicedToArray2.default)(_useState19, 2),
    inputValue = _useState20[0],
    setInputValue = _useState20[1];
  var _useState21 = (0, _react.useState)(false),
    _useState22 = (0, _slicedToArray2.default)(_useState21, 2),
    bypassShowOnFocus = _useState22[0],
    setBypassShowOnFocus = _useState22[1];
  var textInputRef = (0, _react.useRef)(null);
  var tokenizerContainerRef = (0, _react.useRef)(null);
  var overflowTokenRef = (0, _react.useRef)(null);
  var internalDropdownTriggerButtonRef = (0, _react.useRef)(null);
  var popperBodyRef = (0, _react.useRef)(null);
  var listBoxRef = (0, _react.useRef)(null);
  var inputControlRef = (0, _react.useRef)(null);
  var _ref = (0, _react.useContext)(_ComboBoxContext.default) || {},
    isMultiSelect = _ref.isMultiSelect,
    multiSelectionType = _ref.selectionType;
  var comboBoxSelectionType = multiSelectionType || selectionType;
  var screenReaderContentId = (0, _useUniqueId.default)();
  var matcherMethodMutated = comboBoxSelectionType === 'auto' || comboBoxSelectionType === 'manual' ? matcherMethod : 'startsWith';
  var componentId = (0, _useUniqueId.default)();
  if (id) {
    componentId = id;
  }
  var labelId = (0, _useUniqueId.default)();
  if (labelProps !== null && labelProps !== void 0 && labelProps.id) {
    labelId = labelProps.id;
  }
  var listboxId = (0, _useUniqueId.default)();
  if (listboxProps !== null && listboxProps !== void 0 && listboxProps.id) {
    listboxId = listboxProps.id;
  }
  var emptyFilterOptions = !filteredOptions.length && !filteredMruOptions.length;
  var getIsExpanded = function getIsExpanded(expanded) {
    // check to see if there's a reason we can't just use the 'expanded' value
    if (emptyFilterOptions && hideNoResultsMsg) {
      return false;
    }
    return expanded;
  };

  // update filterString (state) and input field text to newString
  var updateFilterStringAndInputText = function updateFilterStringAndInputText(newString) {
    if (!showAllOptionsOnDropdownOpen) {
      setFilterString(newString || '');
    }
    if (textInputRef !== null && textInputRef !== void 0 && textInputRef.current) {
      setInputValue(newString || '');
    }
  };
  var updateFilteredOptions = function updateFilteredOptions() {
    if (filterable) {
      var newFilteredOptions = (0, _utils.getFilteredOptions)({
        searchString: filterString,
        options: options,
        itemText: itemText,
        matcherMethod: matcherMethodMutated
      });
      setFilteredOptions(newFilteredOptions);
    } else {
      setFilteredOptions(options);
    }
    if (filterableMruOptions) {
      var newFilteredMruOptions = (0, _utils.getFilteredOptions)({
        searchString: filterString,
        options: mruOptions,
        itemText: itemText,
        matcherMethod: matcherMethodMutated
      });
      setFilteredMruOptions(newFilteredMruOptions);
    } else {
      // These may have been cleared when clicking the overflow token
      setFilteredMruOptions(mruOptions);
    }
  };

  // map props.options, props.filterable,
  // or filterString (state) changes to -> filteredOptions (state)
  (0, _react.useEffect)(function () {
    updateFilteredOptions();
  }, [options, filterString, filterable, mruOptions, filterableMruOptions]);
  var queueListboxFocus = function queueListboxFocus() {
    setTimeout(function () {
      if (listBoxRef !== null && listBoxRef !== void 0 && listBoxRef.current) {
        var _listBoxRef$current, _listBoxRef$current$f;
        (_listBoxRef$current = listBoxRef.current) === null || _listBoxRef$current === void 0 || (_listBoxRef$current$f = _listBoxRef$current.focus) === null || _listBoxRef$current$f === void 0 || _listBoxRef$current$f.call(_listBoxRef$current);
        setWillFocusPopover(false);
      }
    }, 0);
  };

  // if loading options as a result of showAllOptionsOnDropdownOpen,
  // ensure filtered options is reset
  (0, _react.useEffect)(function () {
    if (!isLoading && isLoadingAllOptions) {
      setFilteredOptions(options);
      setFilteredMruOptions(mruOptions);
      setIsLoadingAllOptions(false);
    } else if (!isLoading) {
      if (willFocusPopover) {
        queueListboxFocus();
      }
    }
  }, [isLoading]);

  // map props.value changes to -> filterString (state) and input field text
  (0, _react.useEffect)(function () {
    updateFilterStringAndInputText(value);
    setNudgeBase(value);
    if (!value) {
      setSelectedOption();
    }
  }, [value]);

  // check if noResultsMsg is visible
  (0, _react.useEffect)(function () {
    // if expanded, hide dropdown if filteredOptions is empty and hideNoResultsMsg is true
    if (isExpanded && emptyFilterOptions && hideNoResultsMsg) {
      setIsExpanded(false);
    }
  }, [isExpanded, emptyFilterOptions, hideNoResultsMsg]);

  // trigger dropdown callbacks
  (0, _useUpdatesOnlyEffect.default)(function () {
    if (isExpanded && (0, _isFunction.default)(onDropdownOpen)) {
      onDropdownOpen();
    } else if (!isExpanded && (0, _isFunction.default)(onDropdownClose)) {
      onDropdownClose();
    }
  }, [isExpanded]);
  (0, _react.useEffect)(function () {
    if (willFocusPopover) {
      queueListboxFocus();
    }
  }, [willFocusPopover]);
  var getPlaceholderOption = function getPlaceholderOption(text) {
    return (0, _defineProperty2.default)((0, _defineProperty2.default)({}, itemKey, NOT_FOUND_KEY), itemText, text);
  };
  var safeOnSelectionChange = function safeOnSelectionChange(event, option, reason) {
    if ((0, _isFunction.default)(onSelectionChange)) {
      onSelectionChange(event, option, reason);
    }
  };

  // if passed option has a different key value than that of the currently selected option
  // update the currently selected option to the passed option,
  // and trigger props.onSelectionChange callback.
  var selectAndCallback = function selectAndCallback(event, option, reason, selectedItems) {
    if (isMultiSelect) {
      safeOnSelectionChange(event, selectedItems, reason);
    } else if ((0, _listboxUtils.reduceOption)(option, itemKey) === NOT_FOUND_KEY || !(0, _utils.isSame)(selectedOption, option, itemKey)) {
      setSelectedOption(option);
      safeOnSelectionChange(event, option, reason);
    }
  };

  // For single select Combobox:
  //  if props.selectedKey changes, update selectedOption,
  //  filterString, and input field text and trigger selection callback
  (0, _react.useEffect)(function () {
    var preSelectedOption = options === null || options === void 0 ? void 0 : (0, _find.default)(options).call(options, function (option) {
      return (0, _listboxUtils.reduceOption)(option, itemKey) === selectedKey;
    });
    var currentKey = selectedOption ? (0, _listboxUtils.reduceOption)(selectedOption, itemKey) : NOT_FOUND_KEY;
    var isChanged = currentKey !== selectedKey;
    if (isChanged) {
      if (selectedKey === NOT_FOUND_KEY) {
        selectAndCallback(null, getPlaceholderOption(value), 'preSelection');
        updateFilterStringAndInputText(value);
      } else if (preSelectedOption) {
        selectAndCallback(null, preSelectedOption, 'preSelection');
        updateFilterStringAndInputText((0, _listboxUtils.reduceOption)(preSelectedOption, itemText));
      }
    }
  }, [selectedKey, options, value]);

  // For MultiCombobox:
  //  if props.selectedKeys changes, update multiSelectedOptions
  (0, _react.useEffect)(function () {
    var preselectedOptions = [];
    if (selectedKeys !== null && selectedKeys !== void 0 && selectedKeys.length) {
      selectedKeys.forEach(function (key) {
        var matchedObject = (0, _find.default)(options).call(options, function (option) {
          return (0, _listboxUtils.reduceOption)(option, itemKey) === key;
        });
        preselectedOptions.push(matchedObject);
      }, {});
    }
    if (preselectedOptions.length) {
      setMultiSelectOptions(preselectedOptions);
    } else {
      setMultiSelectOptions([]);
    }
  }, [selectedKeys, options]);
  var classnames = _bind.default.bind(_ComboBox.default);

  // DOM and State Manipulation
  var closePopover = function closePopover() {
    setIsExpanded(false);
    updateFilteredOptions();
  };
  var openAndFocusPopover = function openAndFocusPopover() {
    var expandedValue = getIsExpanded(true);
    setIsExpanded(expandedValue);
    setWillFocusPopover(expandedValue);
  };
  var queueInputFocus = function queueInputFocus(callback) {
    var _textInputRef$current;
    if (textInputRef !== null && textInputRef !== void 0 && (_textInputRef$current = textInputRef.current) !== null && _textInputRef$current !== void 0 && _textInputRef$current.focus) {
      setTimeout(function () {
        var _textInputRef$current2, _textInputRef$current3, _textInputRef$current4;
        var end = (textInputRef === null || textInputRef === void 0 || (_textInputRef$current2 = textInputRef.current) === null || _textInputRef$current2 === void 0 || (_textInputRef$current2 = _textInputRef$current2.value) === null || _textInputRef$current2 === void 0 ? void 0 : _textInputRef$current2.length) || 0;
        textInputRef === null || textInputRef === void 0 || (_textInputRef$current3 = textInputRef.current) === null || _textInputRef$current3 === void 0 || _textInputRef$current3.setSelectionRange(end, end);
        textInputRef === null || textInputRef === void 0 || (_textInputRef$current4 = textInputRef.current) === null || _textInputRef$current4 === void 0 || _textInputRef$current4.focus();
        if ((0, _isFunction.default)(callback)) {
          callback();
        }
      }, 0);
    }
  };
  var safeOnChange = function safeOnChange(event) {
    if ((0, _isFunction.default)(onChange)) {
      onChange(event);
    }
  };
  var reset = function reset(event) {
    closePopover();
    selectAndCallback(event, getPlaceholderOption(''), 'escKeyDown');
    updateFilterStringAndInputText();
    safeOnChange(event);
    queueInputFocus();
  };

  // returns true if someOption is found in multiSelectOptions (state)
  var inMultiSelectedOptions = function inMultiSelectedOptions(someOption) {
    return !!(0, _find.default)(multiSelectOptions).call(multiSelectOptions, function (eachSelectedOption) {
      return (0, _utils.isSame)(eachSelectedOption, someOption, itemKey);
    });
  };

  // removes removedOption from multiSelectOptions (state)
  var removeOption = function removeOption(removedOption, event, reason) {
    var filteredSelectedOptions = (0, _filter.default)(multiSelectOptions).call(multiSelectOptions, function (eachOption) {
      return !(0, _utils.isSame)(eachOption, removedOption, itemKey);
    });
    setMultiSelectOptions(filteredSelectedOptions);
    selectAndCallback(event, undefined, reason, filteredSelectedOptions);
  };

  // set selected option, and trigger selection callback
  //
  // if MultiCombobox: add option if not already added else remove it.
  //
  // if Combobox: use option.text as filter string and
  //  set input value to value returned by itemText
  // and close the popover.
  var selectUpdateClose = function selectUpdateClose(event, option, reason) {
    if (isMultiSelect) {
      if (!inMultiSelectedOptions(option)) {
        var _context, _context2;
        setMultiSelectOptions((0, _concat.default)(_context = [option]).call(_context, (0, _toConsumableArray2.default)(multiSelectOptions)));
        selectAndCallback(event, option, reason, (0, _concat.default)(_context2 = [option]).call(_context2, (0, _toConsumableArray2.default)(multiSelectOptions)));
      } else {
        removeOption(option, event, reason);
      }
    } else {
      var optionText = (0, _listboxUtils.reduceOption)(option, itemText);
      selectAndCallback(event, option, reason);
      setInputValue(optionText);
      setFilterString(optionText);
      closePopover();
    }
  };

  // String, collection, and DOM utils

  // get the first option from filteredOptions,
  // if no filteredOptions (based on searchString) return placeholder option.
  var getFirstFilteredOption = function getFirstFilteredOption(searchString) {
    var matchedOptions = (0, _utils.getFilteredOptions)({
      searchString: searchString,
      options: options,
      itemText: itemText,
      matcherMethod: matcherMethodMutated
    });
    return matchedOptions !== null && matchedOptions !== void 0 && matchedOptions.length ? matchedOptions[0] : getPlaceholderOption(searchString);
  };

  // get the first option filteredOption and select it
  var autoSelectFirstOption = function autoSelectFirstOption(event, searchString, reason) {
    if (searchString) {
      var firstOption = getFirstFilteredOption(searchString);
      if (firstOption) {
        selectUpdateClose(event, firstOption, reason);
      }
    }
  };

  // create input field text selection for various browsers,
  // this is used to show the type-ahead nudge
  var createSelection = function createSelection(field, start, end) {
    if (field !== null && field !== void 0 && field.createTextRange) {
      var selRange = field.createTextRange();
      selRange.collapse(true);
      selRange.moveStart('character', start);
      selRange.moveEnd('character', end);
      selRange.select();
    } else if (field !== null && field !== void 0 && field.setSelectionRange) {
      field.setSelectionRange(start, end);
    } else if (field !== null && field !== void 0 && field.selectionStart) {
      // eslint-disable-next-line no-param-reassign
      field.selectionStart = start;
      // eslint-disable-next-line no-param-reassign
      field.selectionEnd = end;
    }
  };
  var getTokens = function getTokens() {
    return (0, _tabbable.tabbable)(tokenizerContainerRef === null || tokenizerContainerRef === void 0 ? void 0 : tokenizerContainerRef.current);
  };
  var getActiveTokenIndex = function getActiveTokenIndex(tokens) {
    if (!tokens.length) return -1;
    var activeTokenIndex = -1;
    for (var i = 0; i < tokens.length; i += 1) {
      if (tokens[i] === document.activeElement) {
        activeTokenIndex = i;
        break;
      }
    }
    return activeTokenIndex;
  };

  // focus on the last token in the tokenizer,
  // this can either be an option token or the overflow token [x more]
  var focusLastToken = function focusLastToken() {
    var tokens = getTokens();
    if (tokens.length) {
      var lastToken = tokens[tokens.length - 1];
      lastToken === null || lastToken === void 0 || lastToken.focus();
    } else {
      queueInputFocus(); // fallback focus on input
    }
  };

  // if any tokens (except for the first) are active element, set focus on the previous
  var focusPreviousToken = function focusPreviousToken() {
    var tokens = getTokens();
    var activeTokenIndex = getActiveTokenIndex(tokens);
    var previousToken = activeTokenIndex >= 1 ? tokens[activeTokenIndex - 1] : undefined;
    previousToken === null || previousToken === void 0 || previousToken.focus();
  };

  // if any tokens (except for last) are active element, set focus on the next
  // if last token is active element, focus on input
  var focusNextToken = function focusNextToken() {
    var tokens = getTokens();
    var activeTokenIndex = getActiveTokenIndex(tokens);
    if (activeTokenIndex === tokens.length - 1) {
      queueInputFocus();
    } else {
      var nextToken = activeTokenIndex >= 0 && activeTokenIndex < tokens.length - 1 ? tokens[activeTokenIndex + 1] : undefined;
      nextToken === null || nextToken === void 0 || nextToken.focus();
    }
  };
  var focusTokenByIndex = function focusTokenByIndex(indexToFocus) {
    var tokens = getTokens();
    var tokenToFocus = tokens[indexToFocus];
    tokenToFocus === null || tokenToFocus === void 0 || tokenToFocus.focus();
  };

  // Event handling
  var handleTriggerButtonClick = function handleTriggerButtonClick(event) {
    event.preventDefault();
    if (!isExpanded) {
      openAndFocusPopover();
      if (showAllOptionsOnDropdownOpen) {
        setFilteredOptions(options);
        setFilteredMruOptions(mruOptions);
        setIsLoadingAllOptions(true);
      }
    }
  };
  var handleTriggerButtonKeyDown = function handleTriggerButtonKeyDown(event) {
    var keyCodeString = (0, _keycode.default)(event);
    if (keyCodeString === 'tab' || keyCodeString === 'esc') {
      closePopover();
    }
  };
  var handleInputKeyDown = function handleInputKeyDown(event) {
    var _event$target, _event$target2, _event$target3;
    var textFieldValue = event === null || event === void 0 || (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value;
    switch ((0, _keycode.default)(event)) {
      case 'backspace':
        setInputValue(filterString);
        // cursor at the very beginning of the input field
        // no text selected in the input field
        if (isMultiSelect && (event === null || event === void 0 || (_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : _event$target2.selectionStart) === 0 && (event === null || event === void 0 || (_event$target3 = event.target) === null || _event$target3 === void 0 ? void 0 : _event$target3.selectionEnd) === 0) {
          focusLastToken();
        }
        break;
      case 'enter':
        switch (comboBoxSelectionType) {
          case 'manual':
            event.preventDefault();
            break;
          default:
            event.preventDefault();
            autoSelectFirstOption(event, textFieldValue, 'inputKeyDown');
            break;
        }
        break;
      case 'esc':
        reset(event);
        break;
      case 'tab':
        switch (comboBoxSelectionType) {
          case 'auto':
          case 'auto-inline':
            autoSelectFirstOption(event, textFieldValue, 'inputKeyDown');
            break;
          default:
        }
        closePopover();
        break;
      case 'down':
      case 'up':
        {
          if (!readOnly && !disabled) {
            openAndFocusPopover();
            if (showAllOptionsOnDropdownOpen && !isExpanded) {
              setFilteredOptions(options);
              setFilteredMruOptions(mruOptions);
              setIsLoadingAllOptions(true);
            }
          }
          break;
        }
      case 'left':
        {
          var _event$target4;
          if (isMultiSelect && (event === null || event === void 0 || (_event$target4 = event.target) === null || _event$target4 === void 0 ? void 0 : _event$target4.selectionStart) === 0) {
            focusLastToken();
          }
        }
      // eslint-disable-next-line no-fallthrough
      case 'right':
        setFilterString(textFieldValue);
        break;
      default:
    }
  };
  var handleInputChange = function handleInputChange(event) {
    var _event$target5;
    var targetInputValue = event === null || event === void 0 || (_event$target5 = event.target) === null || _event$target5 === void 0 ? void 0 : _event$target5.value;
    setNudgeBase(targetInputValue);
    setFilterString(targetInputValue);
    setInputValue(targetInputValue);
    if (targetInputValue !== null && targetInputValue !== void 0 && (0, _trim.default)(targetInputValue).call(targetInputValue)) {
      setIsExpanded(getIsExpanded(true));
      switch (comboBoxSelectionType) {
        case 'manual':
          selectAndCallback(event, getPlaceholderOption(targetInputValue), 'inputChange');
          break;
        case 'auto':
          selectAndCallback(event, getFirstFilteredOption(targetInputValue), 'inputChange');
          break;
        case 'type-ahead':
        case 'auto-inline':
          {
            // try type ahead nudge
            var firstOption = getFirstFilteredOption(targetInputValue);
            if (firstOption) {
              var optionText = (0, _listboxUtils.reduceOption)(firstOption, itemText);
              if ((0, _listboxUtils.matcherMethodIgnoreCase)(optionText, targetInputValue, matcherMethodMutated)) {
                textInputRef.current.value = optionText;
                createSelection(textInputRef.current, targetInputValue === null || targetInputValue === void 0 ? void 0 : targetInputValue.length, optionText === null || optionText === void 0 ? void 0 : optionText.length);
                setInputValue(optionText);
              }
            }
            if (comboBoxSelectionType === 'auto-inline') {
              selectAndCallback(event, firstOption, 'inputChange');
            }
            break;
          }
        default:
      }
    } else {
      selectAndCallback(event, getPlaceholderOption(targetInputValue), 'inputChange');
      if ((0, _isFunction.default)(showOnFocus) && showOnFocus(event)) {
        return;
      }
      closePopover();
    }
  };
  var handleInputBlur = function handleInputBlur(event) {
    setBypassShowOnFocus(false);
    switch (comboBoxSelectionType) {
      case 'manual':
        if (!(0, _listboxUtils.reduceOption)(selectedOption, itemKey) && filterString !== null && filterString !== void 0 && (0, _trim.default)(filterString).call(filterString).length) {
          safeOnSelectionChange(event, getPlaceholderOption(filterString), 'inputBlur');
        }
        break;
      case 'auto':
        setFilterString(event.target.value);
        break;
      case 'auto-inline':
        break;
      case 'type-ahead':
        {
          setInputValue(nudgeBase);
          break;
        }
      default:
    }
  };
  var handleOptionKeyDown = function handleOptionKeyDown(event) {
    var keyCode = (0, _keycode.default)(event);
    switch (keyCode) {
      case 'tab':
        {
          setBypassShowOnFocus(true);
          queueInputFocus();
          break;
        }
      case 'home':
      case 'end':
        {
          event.preventDefault();
          event.stopPropagation();
          queueInputFocus(function () {
            if (textInputRef !== null && textInputRef !== void 0 && textInputRef.current) {
              var _textInputRef$current5;
              var cursorPos = keyCode === 'home' ? 0 : textInputRef === null || textInputRef === void 0 || (_textInputRef$current5 = textInputRef.current) === null || _textInputRef$current5 === void 0 || (_textInputRef$current5 = _textInputRef$current5.value) === null || _textInputRef$current5 === void 0 ? void 0 : _textInputRef$current5.length;
              setTimeout(function () {
                createSelection(textInputRef === null || textInputRef === void 0 ? void 0 : textInputRef.current, cursorPos, cursorPos);
              }, 0);
            }
          });
          break;
        }
      default:
        break;
    }
  };
  var handleOverflowTokenClick = function handleOverflowTokenClick(event) {
    if (disabled) return;
    if (!readOnly) {
      if (!isExpanded) {
        setFilteredOptions(multiSelectOptions);
        setFilteredMruOptions([]);
        openAndFocusPopover();
      } else {
        closePopover();
        setFilteredOptions(options);
        setFilteredMruOptions(mruOptions);
      }
    }
    onOverflowTokenClick(event);
  };
  var handleTokenClose = function handleTokenClose(event, removedOption) {
    if (disabled) return;
    if (!readOnly) {
      removeOption(removedOption, event, 'tokenRemoved');
      if (event) {
        onTokenClose(event, removedOption);
      }
    }
  };
  var handleTokenKeyDown = function handleTokenKeyDown(event, targetOption) {
    if (disabled) return;
    switch ((0, _keycode.default)(event)) {
      case 'delete':
      case 'backspace':
        {
          if (!readOnly) {
            var tokenIndex = getActiveTokenIndex(getTokens());
            handleTokenClose(event, targetOption);
            setTimeout(function () {
              focusLastToken();
              focusTokenByIndex(tokenIndex);
            }, 0);
          }
          break;
        }
      case 'left':
        {
          setTimeout(function () {
            focusPreviousToken();
          }, 0);
          break;
        }
      case 'right':
        {
          setTimeout(function () {
            focusNextToken();
          }, 0);
          break;
        }
      case 'tab':
        {
          if (textInputRef !== null && textInputRef !== void 0 && textInputRef.current && !(event !== null && event !== void 0 && event.shiftKey) && !readOnly) {
            event.preventDefault();
            textInputRef.current.focus();
          }
          break;
        }
      default:
        break;
    }
  };

  // Rendering
  var optionContent = function optionContent(_ref3) {
    var _optionText$toLowerCa, _filterString$toLower;
    var option = _ref3.option,
      _ref3$highlightMatchi = _ref3.highlightMatchingText,
      highlightMatchingText = _ref3$highlightMatchi === void 0 ? true : _ref3$highlightMatchi;
    var optionText = (0, _listboxUtils.reduceOption)(option, itemText);
    if ((0, _isFunction.default)(listItemRenderer)) {
      return listItemRenderer(option, filterString);
    }
    var filterStringLength = 0;
    if (filterString) {
      filterStringLength = filterString.length;
    }
    if (!highlightMatchingText || !filterStringLength) {
      return optionText;
    }
    var firstOccurrence = optionText === null || optionText === void 0 || (_optionText$toLowerCa = optionText.toLowerCase) === null || _optionText$toLowerCa === void 0 ? void 0 : _optionText$toLowerCa.call(optionText).indexOf(filterString === null || filterString === void 0 || (_filterString$toLower = filterString.toLowerCase) === null || _filterString$toLower === void 0 ? void 0 : _filterString$toLower.call(filterString));
    if (firstOccurrence === -1) {
      return optionText;
    }
    var leftPart = optionText === null || optionText === void 0 ? void 0 : optionText.substring(0, firstOccurrence);
    var matchingPart = optionText === null || optionText === void 0 ? void 0 : optionText.substring(firstOccurrence, firstOccurrence + filterStringLength);
    var rightPart = optionText === null || optionText === void 0 ? void 0 : optionText.substring(firstOccurrence + filterStringLength);
    return /*#__PURE__*/_react.default.createElement("span", {
      className: classnames("".concat(CSS_BLOCK, "__filtered-item"))
    }, leftPart, /*#__PURE__*/_react.default.createElement("span", {
      className: classnames("".concat(CSS_BLOCK, "__match"))
    }, matchingPart), rightPart);
  };
  var listboxClasses = classnames("".concat(CSS_BLOCK, "__listbox"));
  var getNoResultsScreenReaderText = function getNoResultsScreenReaderText() {
    if (noResultsMsg) {
      var _context3;
      if ((0, _isString.default)(noResultsMsg)) {
        return noResultsMsg;
      }
      return (0, _concat.default)(_context3 = "".concat(noResultsMsg === null || noResultsMsg === void 0 ? void 0 : noResultsMsg.title, ", ")).call(_context3, noResultsMsg === null || noResultsMsg === void 0 ? void 0 : noResultsMsg.description);
    }
    return '';
  };
  var editable = !disabled && !readOnly;
  var screenReaderStatus = '';
  if (isLoading) {
    screenReaderStatus = loadingMessage;
  } else if (emptyFilterOptions && !hideNoResultsMsg) {
    screenReaderStatus = getNoResultsScreenReaderText();
  }
  var screenReaderContent = editable ? /*#__PURE__*/_react.default.createElement("span", {
    className: classnames("".concat(CSS_BLOCK, "--screen-reader-only")),
    id: screenReaderContentId,
    role: "status"
  }, ((_screenReaderStatus = screenReaderStatus) === null || _screenReaderStatus === void 0 ? void 0 : _screenReaderStatus.length) > 0 && screenReaderStatus) : null;
  var noResultsContent = function noResultsContent() {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/jsx-no-useless-fragment
      _react.default.createElement(_react.default.Fragment, null, !(infinite !== null && infinite !== void 0 && infinite.hasMore) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(CSS_BLOCK, "__no-results"))
      }, (noResultsMsg === null || noResultsMsg === void 0 ? void 0 : noResultsMsg.title) || noResultsMsg, (noResultsMsg === null || noResultsMsg === void 0 ? void 0 : noResultsMsg.description) && /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(CSS_BLOCK, "__no-results-description"))
      }, noResultsMsg === null || noResultsMsg === void 0 ? void 0 : noResultsMsg.description)), screenReaderContent))
    );
  };
  var loadingIndicator = function loadingIndicator() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classnames("".concat(CSS_BLOCK, "__loading-container"))
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classnames("".concat(CSS_BLOCK, "__loading"))
    }, /*#__PURE__*/_react.default.createElement(_BusyIndicator.default, {
      message: loadingMessage,
      size: "sm",
      type: "inline",
      visible: true
    })), screenReaderContent);
  };
  var optionsList = function optionsList() {
    var _getOptionsList = (0, _listOptions.getOptionsList)({
        options: filteredOptions,
        mruOptions: filteredMruOptions,
        groupBy: groupBy,
        mruTitle: mruTitle,
        otherGroupHeader: otherGroupHeader
      }),
      isUsingGroups = _getOptionsList.isUsingGroups,
      newOptions = _getOptionsList.newOptions,
      groupLabelRenderer = _getOptionsList.groupLabelRenderer;
    var handleSingleSelection = function handleSingleSelection(event, optionKeyValue) {
      var optionData = (0, _find.default)(options).call(options, function (option) {
        return optionKeyValue === (0, _listboxUtils.reduceOption)(option, itemKey);
      });
      if ((comboBoxSelectionType === 'auto' || comboBoxSelectionType === 'auto-inline') && (event === null || event === void 0 ? void 0 : event.type) !== 'click' && !(0, _isEnterOrSpace.default)(event)) {
        selectAndCallback(event, optionData, 'optionFocus');
        setInputValue((0, _listboxUtils.reduceOption)(optionData, itemText));
      } else {
        selectUpdateClose(event, optionData, 'optionSelected');
        setBypassShowOnFocus(true);
        queueInputFocus();
      }
    };
    var handleMultiSelectionChange = function handleMultiSelectionChange(event, optionKeyValue) {
      var optionData = (0, _find.default)(options).call(options, function (option) {
        return optionKeyValue === (0, _listboxUtils.reduceOption)(option, itemKey);
      });
      selectUpdateClose(event, optionData, 'optionToggled');
    };
    var currentSelectedKey = (0, _listboxUtils.reduceOption)(selectedOption, itemKey);
    var content = /*#__PURE__*/_react.default.createElement(_Listbox.default, (0, _extends2.default)({}, listboxProps, {
      id: listboxId,
      ariaLabelledby: labelId,
      className: listboxClasses,
      size: size,
      groupLabelRenderer: isUsingGroups ? groupLabelRenderer : undefined,
      hideOuterFocusRing: true,
      ignoreFirstAndLastKeys: true,
      infinite: infinite,
      itemKey: itemKey,
      itemText: itemText,
      listItemRenderer: function listItemRenderer(option) {
        return optionContent({
          option: option,
          highlightMatchingText: option !== null && option !== void 0 && option.isMru ? filterableMruOptions : true
        });
      },
      listItemProps: listItemProps,
      maxHeight: maxHeight,
      selectedKey: currentSelectedKey !== NOT_FOUND_KEY ? currentSelectedKey : undefined,
      selectedKeys: (0, _map.default)(multiSelectOptions).call(multiSelectOptions, function (option) {
        return (0, _listboxUtils.reduceOption)(option, itemKey);
      }),
      selectionType: isMultiSelect ? 'multiSelect' : 'singleSelectMaster',
      selectionFollowsFocus: comboBoxSelectionType === 'auto' || comboBoxSelectionType === 'auto-inline',
      options: isUsingGroups ? newOptions : newOptions[0],
      onKeyDown: handleOptionKeyDown,
      onChange: handleSingleSelection,
      onSelectionChange: handleMultiSelectionChange,
      ref: listBoxRef
    }));
    if (emptyFilterOptions) {
      content = noResultsContent();
    }
    return content;
  };
  var popperBody = function popperBody() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classnames("".concat(CSS_BLOCK, "__popper-contents"))
    }, validationMessage && validationMessage.state && validationMessage.text && /*#__PURE__*/_react.default.createElement(_ValidationMessage.default, {
      inPopper: true,
      state: validationMessage.state,
      text: validationMessage.text
    }), !isLoading ? optionsList() : loadingIndicator());
  };
  var classes = classnames(CSS_BLOCK, className);
  var getInputStartDecorators = function getInputStartDecorators() {
    var _context4;
    var decoratorArray = [];
    if (isMultiSelect) {
      decoratorArray.push( /*#__PURE__*/_react.default.createElement(_MultiComboBoxTokenizer.default, {
        itemKey: itemKey,
        itemText: itemText,
        onClose: handleTokenClose,
        onKeyDown: handleTokenKeyDown,
        onOverflowTokenClick: handleOverflowTokenClick,
        removeLabel: (localizedTextAddendum === null || localizedTextAddendum === void 0 ? void 0 : localizedTextAddendum.tokenRemoveLabel) || (localizedTextAddendum === null || localizedTextAddendum === void 0 ? void 0 : localizedTextAddendum.tokenCloseLabel),
        overflowTokenLabel: localizedTextAddendum === null || localizedTextAddendum === void 0 ? void 0 : localizedTextAddendum.more,
        ref: (0, _reactMergeRefs.default)([tokenizerContainerRef, tokenizerRef]),
        selectedOptions: multiSelectOptions,
        size: size,
        overflowTokenRef: overflowTokenRef,
        reservedWidthForSiblings: 275
      }));
    }
    return (0, _concat.default)(_context4 = []).call(_context4, decoratorArray, (0, _toConsumableArray2.default)(_react.default.Children.toArray(decorators === null || decorators === void 0 ? void 0 : decorators.inputStart)));
  };
  var getInputEndDecorators = function getInputEndDecorators() {
    var _context5;
    var decoratorArray = [];
    if (!hideDropdownButton) {
      var dropdownIconSizeMap = {
        lg: 'xs-plus',
        md: 'xs'
      };
      decoratorArray.push( /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({}, dropdownTriggerButtonProps, {
        "aria-label": dropdownTriggerLabel,
        className: classnames(dropdownTriggerButtonProps === null || dropdownTriggerButtonProps === void 0 ? void 0 : dropdownTriggerButtonProps.className),
        disabled: disabled || emptyFilterOptions && hideNoResultsMsg,
        id: "".concat(componentId, "-combobox-arrow"),
        onClick: (0, _chainFunction.default)(handleTriggerButtonClick, onDropdownTriggerClick),
        onKeyDown: (0, _chainFunction.default)(handleTriggerButtonKeyDown, dropdownTriggerButtonProps === null || dropdownTriggerButtonProps === void 0 ? void 0 : dropdownTriggerButtonProps.onKeyDown),
        ref: (0, _reactMergeRefs.default)([internalDropdownTriggerButtonRef, dropdownTriggerButtonRef])
      }), /*#__PURE__*/_react.default.createElement(_Icon.default, {
        ariaHidden: true,
        forceSize: dropdownTriggerIconName === 'arrow-2-s' ? dropdownIconSizeMap[size] : undefined,
        iconName: dropdownTriggerIconName
      })));
    }
    return (0, _concat.default)(_context5 = []).call(_context5, (0, _toConsumableArray2.default)(_react.default.Children.toArray(decorators === null || decorators === void 0 ? void 0 : decorators.inputEnd)), decoratorArray);
  };
  var describedbyString;
  if (typeof inputDescribedby === 'string') {
    describedbyString = inputDescribedby;
  } else if (Array.isArray(inputDescribedby)) {
    var _inputDescribedby$joi;
    describedbyString = (_inputDescribedby$joi = inputDescribedby.join) === null || _inputDescribedby$joi === void 0 ? void 0 : _inputDescribedby$joi.call(inputDescribedby, ' ');
  }
  var itemCountMessage = '';
  var itemCount = ((filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length) || 0) + ((filteredMruOptions === null || filteredMruOptions === void 0 ? void 0 : filteredMruOptions.length) || 0);
  if (isExpanded && itemCount > 0 && inputValue && !isLoading) {
    var _context6;
    itemCountMessage = (0, _concat.default)(_context6 = "".concat(itemCountScreenReaderLabel, " ")).call(_context6, itemCount);
  }
  var renderInputField = function renderInputField(popperTargetRef) {
    var _context7, _context8;
    return /*#__PURE__*/_react.default.createElement(_InputField.default, (0, _extends2.default)({}, otherProps, {
      disableInternalValueStateMgmt: comboBoxSelectionType === 'type-ahead' || comboBoxSelectionType === 'auto-inline',
      enableScreenReaderStatus: !disabled && !readOnly,
      screenReaderMessage: itemCountMessage,
      inputDescribedby: editable && (isLoading || emptyFilterOptions) && isExpanded ? (0, _trim.default)(_context7 = (0, _concat.default)(_context8 = "".concat(describedbyString || '', " ")).call(_context8, screenReaderContentId)).call(_context7) : describedbyString,
      "aria-controls": isExpanded ? inputProps === null || inputProps === void 0 ? void 0 : inputProps.id : null,
      className: classes,
      decorators: _objectSpread(_objectSpread({}, decorators), {}, {
        inputStart: getInputStartDecorators(),
        inputEnd: getInputEndDecorators()
      }),
      disabled: disabled,
      helpText: helpText,
      id: "".concat(componentId, "-combobox"),
      label: label,
      labelProps: _objectSpread(_objectSpread({}, labelProps), {}, {
        id: labelId
      }),
      onBlur: (0, _chainFunction.default)(handleInputBlur, function (event) {
        if (!isExpanded && (0, _isFunction.default)(onBlur)) {
          onBlur(event);
        }
      }),
      onChange: (0, _chainFunction.default)(handleInputChange, safeOnChange),
      onFocus: function onFocus(event) {
        if ((0, _isFunction.default)(showOnFocus) && !readOnly && !disabled) {
          if (!bypassShowOnFocus) {
            if (showAllOptionsOnDropdownOpen) {
              setFilteredOptions(options);
              setFilteredMruOptions(mruOptions);
              setIsLoadingAllOptions(true);
            }
            setIsExpanded(getIsExpanded(showOnFocus(event)));
          }
        }
        if ((0, _isFunction.default)(_onFocus)) {
          _onFocus(event);
        }
      },
      placeholder: placeholder,
      inputProps: _objectSpread(_objectSpread({
        autoComplete: 'off',
        spellCheck: 'false',
        autoCorrect: 'off',
        autoCapitalize: 'off'
      }, inputProps), {}, {
        id: componentId,
        role: 'combobox',
        'aria-expanded': isExpanded,
        'aria-haspopup': editable ? 'listbox' : false,
        'aria-controls': isExpanded ? listboxId : null,
        'aria-autocomplete': comboBoxSelectionType === 'auto-inline' ? 'both' : 'list',
        onKeyDown: (0, _chainFunction.default)(handleInputKeyDown, function (event) {
          if ((0, _isFunction.default)(onKeyDown)) {
            onKeyDown(event);
          }
        }),
        onMouseDown: function onMouseDown(event) {
          if ((0, _isFunction.default)(_onMouseDown)) {
            _onMouseDown(event);
          }
        }
      }),
      inputRef: (0, _reactMergeRefs.default)([textInputRef, inputRef]),
      controlRef: (0, _reactMergeRefs.default)([controlRef, inputControlRef, popperTargetRef]),
      readOnly: readOnly,
      ref: ref,
      required: required,
      size: size,
      value: inputValue || '',
      validationMessage: validationMessage,
      hideValidationMessage: isExpanded
    }));
  };
  return /*#__PURE__*/_react.default.createElement(_Overlay.default, (0, _extends2.default)({}, overlayProps, {
    popperPlacement: (overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.popperPlacement) || ['bottom-start', 'top-start', 'bottom-end', 'top-end'],
    widthSizingType: (overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.widthSizingType) || 'minTarget',
    onEscapeKey: (0, _chainFunction.default)(function () {
      setBypassShowOnFocus(true);
      closePopover();
      queueInputFocus();
    }, overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.onEscapeKey),
    onHide: (0, _chainFunction.default)(function () {
      closePopover();
    }, overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.onHide),
    popperProps: _objectSpread(_objectSpread({}, overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.popperProps), {}, {
      innerRef: (0, _reactMergeRefs.default)([popperBodyRef, overlayProps === null || overlayProps === void 0 || (_overlayProps$popperP = overlayProps.popperProps) === null || _overlayProps$popperP === void 0 ? void 0 : _overlayProps$popperP.innerRef]),
      role: 'presentation' // remove Overlay's default role of dialog
    }),
    renderTargetComponent: renderInputField,
    show: isExpanded,
    disableFocusManager: true,
    skipTargetModifications: true
  }), popperBody());
});
ComboBox.displayName = 'ComboBox';
ComboBox.propTypes = _objectSpread(_objectSpread({}, _InputField.default.propTypes), {}, {
  /** Localized assistive text for the dropdown trigger button.
   */
  dropdownTriggerLabel: _propTypes.default.string.isRequired,
  /** When ComboBox items are filtered, a screen reader will
   * announce the item count along with this label. For example,
   * itemCountScreenReaderLabel="Countries:" will cause announcements
   * like "Countries:6" when the filtered countries are updated.
   */
  itemCountScreenReaderLabel: _propTypes.default.string.isRequired,
  /**
   * Displayed when no `options` items match entered text. If a string is used,
   * it will display that text.
   * If an object is used, it has props for `title` (primary text)
   * and `description` (secondary text).
   */
  noResultsMsg: _CustomPropTypes.default.conditionallyRequired(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
    title: _propTypes.default.string,
    description: _propTypes.default.string
  })]), function (props) {
    return !props.hideNoResultsMsg;
  }, '`hideNoResultsMsg` is not set'),
  /** Attach a ref to the dropdown trigger `<button>` element. */
  dropdownTriggerButtonRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
  /** Additional props to be spread to the ComboBox dropdown
   * trigger `<button />` element. */
  dropdownTriggerButtonProps: _propTypes.default.object,
  /** Icon to use for ComboBox dropdown trigger button.
   * See list of [Icons](/?path=/docs/components-display-icon--docs#available-icons). */
  dropdownTriggerIconName: _propTypes.default.string,
  /** Set to **false** to disable option filtering.
   *  If **false** `selectionType` will be forced to `'manual'`.
   * You can disable filtering to show a static list of options regardless of the text value,
   * and implement custom filtering.
   * See [custom filtering](#custom-rendering-and-filtering). */
  filterable: _propTypes.default.bool,
  /**
   * If **true** the mruOptions will also be filtered.
   * Default value is **false**
   */
  filterableMruOptions: _propTypes.default.bool,
  /** An object key to use to group list options by.
   * Items will be grouped by that key's value.
   * Un-grouped items will be grouped under `otherGroupHeader`.
   * */
  groupBy: _propTypes.default.string,
  /** Set to **true** to not show or announce when no results match the text
   * entry in the input. Used when the user can add enter values not defined
   * in the list of options. */
  hideNoResultsMsg: _propTypes.default.bool,
  /** Defines the properties for infinite scrolling.
   *
   * `message` (string): Localized text to display while more data is loaded.
   *
   * `hasMore` (bool): ets whether there are more items to be loaded.
   * Event listeners are removed if set to `false`.
   * This can also be used to disable infinite loading.
   * NOTE: Setting `hasMore` to `true` emits a loading message.
   * Having both `isLoading` and `hasMore` set to `true` will result in multiple loading messages.
   *
   * `onLoadMore`(func): A callback when more items are requested by the user.
   */
  infinite: _propTypes.default.shape({
    message: _propTypes.default.string.isRequired,
    hasMore: _propTypes.default.bool,
    onLoadMore: _propTypes.default.func
  }),
  /** Set to **true** to show a loading **BusyIndicator** instead of options. */
  isLoading: _propTypes.default.bool,
  /** Used to identify the unique key for a list item. It identifies the field
   * in the data to use as the key value for the list item.
   */
  itemKey: _propTypes.default.string,
  /** Used to identify the text for a list item. It identifies the field
   * in the data to use as the text for the list item.
   * This is similar to `listItemRenderer`, however this is used more
   * for internal searching and filtering and must return a string rather than
   * a node.
   */
  itemText: _propTypes.default.string,
  /** Additional props to spread to the **Listbox** component. */
  listboxProps: _propTypes.default.object,
  /** Additional props to be spread to all the **Listbox** item components. */
  listItemProps: _propTypes.default.object,
  /**
   * Used to render content for each list item in the dropdown.
   * If a string is used, the value for that key
   *  (from `options` or `mruOptions`) will be shown.
   * If a function is used, it must return a valid node.
   * The function will be passed the row of data (in JSON format).
   */
  listItemRenderer: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  /** Text for **BusyIndicator** while data is loading.
   * Must be non-empty if `isLoading` is true. */
  loadingMessage: _propTypes.default.string,
  /** Localized title of most-recently-used (MRU) section inside options list.
   */
  mruTitle: function mruTitle(props, propName, componentName) {
    var mruOptions = props.mruOptions;
    if ((mruOptions === null || mruOptions === void 0 ? void 0 : mruOptions.length) > 0) {
      return _CustomPropTypes.default.localizedString('CoreUIComponents.mostRecentlyUsed').isRequired(props, propName, componentName, 'prop', 'mruTitle');
    }
    return null;
  },
  /** Localized title for un-grouped combobox options.
   * If unset un-grouped options will appear at the top
   * without a header.
   */
  otherGroupHeader: _propTypes.default.string,
  /** Sets method used for filtering results based on user input. The `'includes'`
   * option is only supported with `selectionType='auto'` or `selectionType='manual'`.
   */
  matcherMethod: _propTypes.default.oneOf(_constants.STRING_MATCHER_METHODS),
  /** CSS value for maxHeight property of listbox dropdown popover. */
  maxHeight: _propTypes.default.string,
  /**
   * Raw data for the most-recently used (MRU) items (in JSON format).
   * Each option needs to have a unique key and a simple string representation of its
   * value defined.  Use `itemKey` and `itemText` to define these.
   * For custom rendering of list items, see `listItemRenderer`.
   */
  mruOptions: _propTypes.default.array,
  /** Raw data for the dropdown options. Each element in the array (in JSON format)
   * represents an option in the ComboBox dropdown.
   * Each option needs to have a unique key and a simple string representation of its
   * value defined.  Use `itemKey` and `itemText` to define these.
   * For custom rendering of list items, see `listItemRenderer`.
   * See [custom filtering](#custom-rendering-and-filtering).
   */
  options: _propTypes.default.array,
  /** Additional props to be spread to the underlying **Overlay** component. */
  overlayProps: _propTypes.default.object,
  /** The key corresponding to the selected option. If there is a need to "clear" the
   * selected key, please use the `NOT_FOUND_KEY` constant to represent the empty state.
   */
  selectedKey: _propTypes.default.string,
  /** String representing option selection behaviors:
   *
   * * `'manual'`: User has to manually select the option by
   *  navigating through the listbox options
   * * `'auto'`: First option from the filtered options is automatically selected,
   *  user chooses different option by navigating through the list
   * * `'auto-inline'`: As a user types in the input, filtered option value is populated
   *  inline and automatically selected, or user chooses different option
   *  by navigating through the list.
   */
  selectionType: _propTypes.default.oneOf(COMBOBOX_SELECTION_TYPES),
  /** Set to **true** to show all options upon clicking the dropdown trigger button
   * or using the down arrow key, regardless of current text input. */
  showAllOptionsOnDropdownOpen: _propTypes.default.bool,
  /** Attach a ref to the **MultiComboBox** tokenizer `<div>` element. */
  tokenizerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
  /** Hides the dropdown button if `true` */
  hideDropdownButton: _propTypes.default.bool,
  /** Initial (default) value of input field.
   *  This will not select a value.
   *  To set selected value see `selectedKey` */
  value: _propTypes.default.string,
  /** Callback function; triggered when input field is focused.
   * it's return value will determine if the options list should be shown.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @returns {Boolean}
   */
  showOnFocus: _propTypes.default.func,
  /** Callback function for `<input />` field onKeyDown.
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html. */
  onKeyDown: _propTypes.default.func,
  /** Callback function for `<input />` field onMouseDown.
   *@param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html. */
  onMouseDown: _propTypes.default.func,
  /** Callback function for when the dropdown closes. */
  onDropdownClose: _propTypes.default.func,
  /** Callback function for when the dropdown opens. */
  onDropdownOpen: _propTypes.default.func,
  /** Callback function for onClick on the dropdown trigger button.
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.  */
  onDropdownTriggerClick: _propTypes.default.func,
  /** Callback function; triggered when the selected option changes.
   * There can be many reasons for a selection change depending
   *  on the `selectionType` of the ComboBox.
   * The reason is available as a String and could be one of
   *
   *  * `preSelection`: when the `selectedKey` prop is set/changed,
   * causing a selection
   *  * `optionSelected`: when an option is selected from the listbox by
   * pressing `enter`, `space`, `tab` or a mouse click.
   *  * `inputBlur`: when `selectionType` is manual,
   *  a custom `value` is set and input is blurred
   *  * `inputChange`: when changing input value by typing text causes
   * auto selection in `auto` and `auto-inline` type ComboBoxes
   *  * `optionFocus`: when an option in the listbox receives focus in `auto` or `auto-inline`
   * type ComboBoxes, causing a selection
   *  * `escKeyDown`: when ComboBox is cleared by pressing esc key anytime
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @param {Object} selected - the selected option object. Will contain at
   *  least the 'key' and 'text' properties.
   * @param {string} reason - what caused the selection to change
   * @returns {void}
   */
  onSelectionChange: _propTypes.default.func
});
ComboBox.defaultProps = _objectSpread(_objectSpread({}, _InputField.default.defaultProps), {}, {
  dropdownTriggerIconName: 'arrow-2-s',
  filterable: true,
  filterableMruOptions: false,
  itemKey: 'key',
  itemText: 'text',
  listItemRenderer: 'text',
  matcherMethod: 'startsWith',
  maxHeight: '30vh',
  mruOptions: [],
  options: [],
  selectionType: 'manual',
  value: '',
  onDropdownTriggerClick: function onDropdownTriggerClick() {},
  onKeyDown: function onKeyDown() {},
  onMouseDown: function onMouseDown() {},
  onSelectionChange: function onSelectionChange() {}
});
var _default = exports.default = ComboBox;